module.exports = __webpack_public_path__ + "static/media/image_none_bg.fef8a284.svg";